var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-wrapper"},[_c('main-nav'),_c('home-main-nav',{staticClass:"home-main-nav-sm"}),_c('div',{staticClass:"home-main-wrap"},[_c('home-main-content'),_c('main-sidebar-right')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }